export default __webpack_public_path__ + "static/media/G0065.34I-39579_-23440_0.d5d992b6.jpg";